export default defineNuxtRouteMiddleware(async ({ params, query }) => {
  const { countryFrom, countryTo, currencyFrom, currencyTo, amount } = processIMTParams(params)

  if (!currencyFrom || !currencyTo) {
    return navigate(
      getTransferUrl({
        countryFrom,
        countryTo,
        currencyFrom: countryFrom.defaultCurrency,
        currencyTo: countryTo.defaultCurrency,
        amount,
      }),
      { replace: true, redirectCode: 301 },
    )
  }

  if (query.mode === 'live') {
    const { mode, ...rest } = query
    const path = getIMTLiveUrl({ countryFrom, countryTo, currencyFrom, currencyTo, amount })
    return navigate({ path, query: rest }, { replace: true, redirectCode: 301 })
  }
})
